import React, { useState, useCallback } from "react";
import ListReports from "./list.jsx";
import FormReports from "./form.jsx";
import PermissionCard from "./permissionCard.jsx";
import api from "../../services/client/api";
import cookie from "../../services/cookie/index";
import { SessionManager } from "../../utils/functions";

export default function Reports() {
  const [reports, setReports] = useState([]);
  const [message, setMessage] = useState("");
  const [fields, setFields] = useState({
    dateStart: "",
    dateEnd: "",
    patient: "",
  });
  const [inProgress, setInProgress] = useState(false);
  const token = cookie().get("token");
  const [loadedByPermission, setLoadedByPermission] = useState(false);
  const listPerPage = 100;
  const [qtdReports, setQtdReports] = useState(0);
  const session = SessionManager();
  const [pageSelected, setPageSelected] = useState(1);

  const requirePermission = cookie().get("requirePermission") === "true";

  const usePermissionCard =
    requirePermission && cookie().get("DocList") !== "false";
  const [permissionGranted, setPermissionGranted] =
    useState(!requirePermission);

  const cleanSearch = useCallback(
    (message = "") => {
      setFields({ dateStart: "", dateEnd: "", patient: "" });
      setMessage(message);
      setReports([]);
    },
    [setFields, setMessage, setReports],
  );

  const getSizeReports = useCallback(async () => {
    const response = await api()
      .report()
      .getSizeList(token, fields.dateStart, fields.dateEnd, fields.patient);

    if (response.status === 401) {
      await session.logoff();
      return 0;
    }

    if (response.status === 200) {
      return response.output;
    }
    return 0;
  }, [fields, token, session]);

  const loadReports = useCallback(({ exams, size }) => {
    setReports(exams);
    setQtdReports(size);
    setMessage(`${size} resultados encontrados`);
    setPageSelected(1);

    setPermissionGranted(true);
    setLoadedByPermission(true);
  }, []);
  const getReports = useCallback(
    async (e) => {
      e.preventDefault();

      setInProgress(true);

      const size = await getSizeReports();

      if (size === 0) {
        cleanSearch("Nenhum laudo encontrado");
        setInProgress(false);
        setQtdReports(0);
        return;
      }

      const response = await api()
        .report()
        .get(
          token,
          listPerPage,
          1,
          fields.dateStart,
          fields.dateEnd,
          fields.patient,
        );

      if (response.status === 200) {
        loadReports({
          exams: response.output,
          size,
        });
        setQtdReports(size); // mantém o total real
        setMessage(`${size} resultados encontrados`);
        setInProgress(false);
        return;
      }

      cleanSearch("Nenhum laudo encontrado");
      setInProgress(false);
    },
    [fields, token, getSizeReports, cleanSearch, loadReports],
  );

  const getOtherPage = useCallback(
    async (page) => {
      const response = await api()
        .report()
        .get(
          token,
          listPerPage,
          1,
          fields.dateStart,
          fields.dateEnd,
          fields.patient,
        );

      if (response.status === 200) {
        setReports(response.output);
        setInProgress(false);

        return;
      }

      setReports([]);
    },
    [setInProgress, setReports, token, fields],
  );

  if (usePermissionCard && !permissionGranted) {
    return <PermissionCard onSuccess={loadReports} />;
  }

  return (
    <>
      {(!usePermissionCard || !loadedByPermission) && (
        <FormReports
          setFields={setFields}
          getReports={getReports}
          cleanSearch={cleanSearch}
          inProgress={inProgress}
          fields={fields}
        />
      )}

      <ListReports
        reports={reports}
        message={message}
        getOtherPage={getOtherPage}
        qtdReports={qtdReports}
        listPerPage={listPerPage}
        pageSelected={pageSelected}
        setPageSelected={setPageSelected}
      />
    </>
  );
}
